import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidAppsDeveloped,
  AndroidExperts,
  AndroidIndustry,
} from "../../../app-constants";

const Ratingusa = () => {
  return (
    <div className="rating_usa rating_and tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="rating_box">
              <div className="rating-svg">{AndroidAppsDeveloped}</div>
              <div className="rating-content">
                <div className="rating-num">150+</div>
                <p>Android Apps Developed</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="rating_box">
              <div className="rating-svg">{AndroidExperts}</div>
              <div className="rating-content">
                <div className="rating-num">50+</div>
                <p>Android Experts</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="rating_box">
              <div className="rating-svg">{AndroidIndustry}</div>
              <div className="rating-content">
                <div className="rating-num">15+</div>
                <p>Industries Served</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ratingusa;
